/**
 * Website embed reference - widget script, hosted checkout, and JS API.
 * Setup (domains, warehouses) is done in Integrations UI, not via documented REST routes.
 */

/** Merchant portal (customer-hq) - docs, integrations, login. */
export const MERCHANT_PORTAL_BASE = "https://book.qiktruck.co.za";
/** Consumer checkout (customer-fe) - hosted widget quote page. */
export const CHECKOUT_BASE = "https://qiktruck.co.za/widget/quote";
export const API_BASE = "https://api.qiktruck.co.za";
export const WIDGET_CDN = "https://cdn.qiktruck.co.za/widget.js";

export const NAV = [
  { id: "overview", label: "Overview" },
  { id: "compare", label: "Product comparison" },
  { id: "widget-embed", label: "Widget embed" },
  { id: "checkout-url", label: "Hosted checkout URL" },
];

export const WIDGET_SCRIPT_ATTRS = [
  ["data-qt-site", "Public site id (qt_pub_…). Required.", "-"],
  ["data-qt-mode", "bubble | inline | button", "bubble"],
  ["data-qt-label", "Launcher button text", "Get a delivery price"],
  ["data-qt-position", "Bubble corner: br, bl, tr, tl", "br"],
  ["data-qt-color", "Accent / launcher colour", "#72574d"],
  ["data-qt-description", "Prefill product description for pricing", "-"],
  ["data-qt-trucktype", "Prefill vehicle (e.g. 1tonopen)", "-"],
  ["data-qt-warehouse", "Pickup warehouse id when you have multiple locations", "-"],
  ["data-qt-email / mobile / firstname / lastname", "Prefill shopper contact from checkout", "-"],
  ["data-qt-deliverylat / deliverylng / deliveryaddress", "Prefill delivery destination", "-"],
  ["data-qt-collectionlat / collectionlng", "Override pickup coordinates on this page", "-"],
  ["data-qt-autoquote", "1 = auto-price when enough prefill exists", "auto when complete"],
];

export const CHECKOUT_PARAMS = [
  ["site", "Your qt_pub_… site id", "Required"],
  ["description", "Item / order description used for pricing", "Recommended"],
  ["deliverylat, deliverylng", "Delivery coordinates", "Required for quote"],
  ["deliveryaddress", "Delivery address label shown to shopper", "Optional"],
  ["warehouse", "Pickup warehouse id (from Integrations → Configuration)", "Multi-warehouse stores"],
  ["collectionlat, collectionlng", "Explicit pickup override", "Alternative to warehouse"],
  ["trucktype", "Vehicle type slug", "Optional"],
  ["email, mobile, firstname, lastname", "Shopper contact prefill", "Express checkout"],
  ["promocode", "Promo code override", "Optional"],
  ["autoquote", "0 to disable auto-pricing", "Default on"],
  ["source_", "Attribution (auto-set by widget)", "widget:qt_pub_…"],
];

export const JS_API = [
  { sig: "QikTruck.init(config?)", desc: "Initialize widget. Auto-runs when script has data-qt-site." },
  { sig: "QikTruck.open(overrides?)", desc: "Open hosted checkout modal. Pass prefill overrides (description, destination, email, etc.)." },
  { sig: "QikTruck.update(partial)", desc: "Update config and reload iframe if open." },
  { sig: "QikTruck.close()", desc: "Close the modal." },
  { sig: "QikTruck.config()", desc: "Return current merged config object." },
  { sig: "onQuoted callback", desc: "Set onQuoted in init config - fired when checkout posts qiktruck:quoted." },
];
